<template>
  <div class="flex flex-col items-center">
    <p class="h-8 px-6">END CAP</p>
    <div class="flex">
      <div v-if="part.outlet_size && ! toRightFlow" class="flex items-end"><span class="w-4 h-4 bg-black">&nbsp;</span></div>
      <div class="w-2 part" :style="{'height': height }" :class="selected ? 'selected' : 'allowed'" @click="$emit('input', part)">&nbsp;</div>
      <div v-if="part.outlet_size && toRightFlow" class="flex items-end"><span class="w-4 h-4 bg-black">&nbsp;</span></div>
    </div>
    <p v-if="part.outlet_size" class="text-xs">Outlet <br />{{ part.outlet_size }}"</p>
  </div>
  <!-- end cap -->
</template>

<script>

export default {
  props: {
    part: Object,
    height: String,
    selected: Boolean,
    toRightFlow: Boolean,
  },
  emits: ['input'],
}
</script>
